import styled from 'styled-components';
import { Modal } from 'ggApp/modules/modal/components/v3';
import CircleLoader from 'ggApp/shared/components/CircleLoader';
import ArrowNextIcon from '../assets/arrow_up_right.svg';

const MODAL_CONTAINER_CLASS_NAME = 'EnergySheetContainer';
const MODAL_CONTENT_CLASS_NAME = 'EnergySheetContent';

const StyledModal = styled(Modal).attrs({
    classNames: {
        container: MODAL_CONTAINER_CLASS_NAME,
        content: MODAL_CONTENT_CLASS_NAME,
    },
})`
    & .${MODAL_CONTAINER_CLASS_NAME} {
        width: 384px;
        ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        width: 80%;
        min-height: unset;
        min-width: unset;
    `};
    }

    & .${MODAL_CONTENT_CLASS_NAME} {
        padding: unset;
    }
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
`;

const Title = styled.h3`
    font-size: 24px;
    line-height: 120%;
    font-weight: 800;
`;

const HorizontalDiv = styled.div`
    display: flex;
    align-items: flex-start;
    margin: 16px 0;
`;

const LinkToPDF = styled.a`
    font-size: 16px;
    line-height: 150%;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
    color: black;

    &:hover {
        color: black;
    }
`;

const Arrow = styled.button`
    width: 20px;
    height: 20px;
    background-color: #fff;
    cursor: pointer;
    margin-left: 10px;
`;

const NextArrow = styled(Arrow)`
    background-image: url(${ArrowNextIcon});
`;

const EnergySpecImage = styled.img`
    height: auto;
    width: 100%;
`;

const Loading = styled(CircleLoader)`
    padding: 200px 50px;
`;

export {
    StyledModal,
    Container,
    Title,
    LinkToPDF,
    NextArrow,
    HorizontalDiv,
    EnergySpecImage,
    Loading,
};
